import connector from 'Utils/connector';
import Signup from 'Webapp/shared/app/views/signup';

export default connector({
  selectors: {},
})(Signup);
